/**
 * ForecastChart (需要想定 多系列チャート) の plot 領域レイアウト定数。
 *
 * WeatherBar (気象情報バー) の時刻セル行を ForecastChart の X 軸コマと横位置で
 * 整列させるため、両コンポーネントがこの定数を共有する (値の二重定義をしない、
 * design/demand/forecast-today.html の weather-strip 整列要求 + DetailChart /
 * RegionChart (BalanceDemand 系) の既存の静的スペーサーパターンを踏襲)。
 *
 * Recharts の `margin` は chart 全体の外側余白、`YAxis width` はその内側で
 * 軸ラベル用に確保される幅。したがって plot (CartesianGrid) 領域の左端は
 * コンテナ左端から `CHART_MARGIN.left + CHART_LEFT_AXIS_WIDTH` (負の margin は
 * 全体を左へ寄せる)、右端はコンテナ右端から `CHART_MARGIN.right (+
 * CHART_RIGHT_AXIS_WIDTH、右軸表示時のみ)` の位置になる。
 */
/**
 * `right` は **最終目盛りラベルの半分** を収める幅でもある (#6666)。
 * X 軸の最終ラベル (当日断面 `24:00` / 翌日断面 `27:00`) は plot 領域の右端に
 * 中央揃えで描かれるので、`right` が `ラベル幅 / 2` を下回るとラベルが SVG の外へ
 * はみ出す。11px の `24:00` は 40px 幅なので **20px 必要**で、旧値 12px では
 * どの画面幅でも一定して 8px はみ出していた (Chromium 実測)。今はカードの
 * padding (16px) に吸われて見えているだけで、余白の無いコンテナに置いた瞬間に
 * 見切れる。右 YAxis 表示時は `CHART_RIGHT_AXIS_WIDTH` (40px) が加算されるので
 * 元から足りている。
 */
/**
 * `left` は **前端の斜め X 軸ラベルを SVG 内に収める幅** でもある。
 *
 * -45° の前端ラベル「前日23:00」は目盛りから左上へ伸びる。Chromium 実測で
 * 文字長 54.4px / 回転後の水平リーチ 46.2px なので、目盛り x
 * (= `CHART_MARGIN.left + CHART_LEFT_AXIS_WIDTH`) がこれを下回るとラベルが
 * SVG の外へ出て、祖先のどこかで切られる。
 *
 * 旧値 -8 では目盛り x = 48 で **余裕が 2.5px しか無く**、フォントが変われば
 * 符号が反転する状態だった (実際に見切れた。2026-09-03 デザイナー指摘)。
 * SVG の `overflow` を開けて padding に逃がす手もあるが、2px を争う設計自体を
 * やめて実余白を持たせる。+4 にすると目盛り x = 60 で 9.8px の余裕になる (旧値は 2.5px)。
 *
 * WeatherBar が同じ定数を共有するので、変えても整列は自動で保たれる。
 */
export const CHART_MARGIN = { top: 12, right: 20, left: 4, bottom: 4 }

/** 左 YAxis (需要想定値、kWh) の幅。 */
export const CHART_LEFT_AXIS_WIDTH = 56

/** 右 YAxis (気温・露点、℃) の幅。気温・露点データがある時のみ表示される。 */
export const CHART_RIGHT_AXIS_WIDTH = 40
